// File: Navbar.js

import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Navbar.css";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { currentUser, logoutAction } from "../../Redux/Auth/Action";
import { getUserByLoginId } from "../../Redux/NewHire/Action";
import { USER_DETAILS } from "../../Redux/NewHire/ActionType";
import { IoHome, IoTimeSharp } from "react-icons/io5";
import { FaBusinessTime, FaGear, FaGem } from "react-icons/fa6";
import { RiTaskFill } from "react-icons/ri";
import { MdTimerOff } from "react-icons/md";
import { HiUserGroup } from "react-icons/hi2";
import Swal from "sweetalert2";


const Navbar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");
  const loginId = localStorage.getItem("loginId");
  const { auth } = useSelector((store) => store);
  const { userDetails } = useSelector((store) => store.newHireData);

  const [Role, setRole] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (token) {
      const decode = JSON.parse(atob(token.split(".")[1]));

      if (decode.exp * 1000 < Date.now()) {
        Swal.fire({
          icon: "warning",
          title: "Session Expired",
          text: "Please sign in again.",
          allowOutsideClick: false, //  Freeze background - no click outside
          allowEscapeKey: false,    // ESC cannot close
          allowEnterKey: false,     //  Enter cannot close
          backdrop: true,           //  Dim background
          heightAuto: false         //  Prevent UI shift
        }).then(() => {
          dispatch(logoutAction());
          navigate("/signin");
        });
      }
    } else {
      navigate("/signin");
    }
  }, [dispatch, token]);


  useEffect(() => {
    dispatch(currentUser(token));
    dispatch(getUserByLoginId(loginId, token, USER_DETAILS));
  }, [dispatch, token, loginId]);

  useEffect(() => {
    if (auth && auth.reqUser) {
      setRole(auth.reqUser.role);
      setLoading(false);
    } else {
      setLoading(true);
    }
  }, [auth]);

  const handleLogout = () => {
    dispatch(logoutAction());
    navigate("/signin");
  };

  const hireDetails = () => {
    navigate("/newHireDetails", {
      state: {
        rowData: userDetails,
      },
    });
  };

  const expandNav = () => {
    const nav = document.getElementById("navbarNav");
    if (nav) nav.style.display = nav.style.display === "block" ? "none" : "block";
  };

  if (loading) return <div>Loading...</div>;

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-welcome fixed-top">
        <div className="container-fluid">
          <span className="navbar-text">Welcome to HRMS</span>
          <div className="d-flex ms-auto">
            <div className="me-2 text-white fw-bold mt-2 cs-username">
              {userDetails.firstName} {userDetails.lastName}
            </div>
            <div className="btn-group" >
              <div
                className="dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={{ cursor: "pointer", borderRadius: "50px" }}
              >
                <img
                  src={`data:image/png;base64,${auth?.reqUser?.photo}`}
                  alt="user"
                  style={{ maxWidth: "40px", borderRadius: "50%" }}
                />
              </div>
              <ul className="dropdown-menu dropdown-menu-end">
                {Role && Role !== "ROLE_CANDIDATE" && Role !== "ROLE_CONTRACT" && (
                  <li><button className="dropdown-item" onClick={hireDetails}>My Profile</button></li>
                )}
                <li><a className="dropdown-item" href="/changePassword">Change Password</a></li>
                <li><a className="dropdown-item" href="/">Help</a></li>
                <li><hr className="dropdown-divider" /></li>
                <li><button className="dropdown-item" onClick={handleLogout}>Logout</button></li>
              </ul>
            </div>
          </div>
        </div>
      </nav>

      <nav className="navbar navbar-expand-lg navbar-custom navbar-dark" style={{ top: "48px" }}>
        <button className="navbar-toggler" onClick={expandNav}>
          <span className="navbar-toggler-icon mt-3"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav mt-3">
            <li className="nav-item"><a className="nav-link" href="/"><IoHome /> Home</a></li>
            {Role && Role !== "ROLE_CANDIDATE" && Role !== "ROLE_CONTRACT" && (
              <>

                {Role !== "ROLE_EMP" &&
                  <li li className="nav-item ">
                    <a className="nav-link" href="#"><FaBusinessTime />Daily Updates</a>
                    <ul className="drop-task">
                      <li><a href="/dailyUpdate">Fill Daily Update</a></li>
                      {Role && ["ROLE_ADMIN", "ROLE_MNG", "ROLE_HR"].includes(Role) && (
                        <li><a href="/dailyUpdateApproval">Daily Updates Approval</a></li>
                      )}
                    </ul>
                  </li>
                }

                <li className="nav-item ">
                  <a className="nav-link" href="#"><IoTimeSharp />Timesheet</a>
                  <ul className="drop-task">
                    <li><a href="/timesheet">Fill TimeSheet</a></li>
                    {Role && ["ROLE_ADMIN", "ROLE_MNG", "ROLE_HR"].includes(Role) && (
                      <li><a href="/timesheetApproval">TimeSheet Approval</a></li>
                    )}
                  </ul>
                </li>


                {Role && Role !== "ROLE_SUPPORT" &&
                  <>
                    <li className="nav-item ">
                      <a className="nav-link" href="#"><RiTaskFill /> Task</a>
                      <ul className="drop-task">
                        {Role && ["ROLE_ADMIN", "ROLE_MNG", "ROLE_HR"].includes(Role) && (
                          <>
                            <li><a href="/taskDashboard">Task Dashboard</a></li>
                            {/* <li><a href="/taskAssign">Task Assign</a></li> */}
                          </>
                        )}
                        <li><a href="/taskDetails">Task</a></li>
                        <li><a href="/worklogReport">Worklog Report</a></li>
                      </ul>
                    </li>
                  </>
                }


                <li className="nav-item">
                  <button className="nav-link"><MdTimerOff /> Leave</button>
                  <ul className="drop-task">
                    <li><a href="/leaveApply">Leave Apply</a></li>
                    {Role && ["ROLE_ADMIN", "ROLE_MNG", "ROLE_HR"].includes(Role) && (
                      <>
                        <li><a href="/leaveApproval">Leave Approve</a></li>
                        <li><a href="/leaveReport">Leave Report</a></li>
                        <li><a href="/leaveBalance">Leave Balance</a></li>
                      </>
                    )}
                    <li><a href="/passout">Pass Out</a></li>
                  </ul>
                </li>


                {Role && ["ROLE_ADMIN", "ROLE_MNG", "ROLE_HR"].includes(Role) && (
                  <>
                    <li className="nav-item">
                      <button className="nav-link"><HiUserGroup /> Employee Master</button>
                      <ul className="drop-task">
                        <li><a href="/newhire">NewHires</a></li>
                        <li><a href="/employee">Employee</a></li>
                        <li><a href="/supportEmployee">Support Employee</a></li>
                        <li><a href="/contractEmployee">Contract Employee</a></li>
                      </ul>
                    </li>

                    <li className="nav-item">
                      <button className="nav-link"><FaGear /> Config</button>
                      <ul className="drop-task">
                        <li><a href="/client">Client</a></li>
                        <li><a href="/">Project</a></li>
                        <li><a href="/notice">Notice</a></li>
                        <li><a href="/social">SocialPost</a></li>
                        <li><a href="/alert">Alert</a></li>
                        <li><a href="/customer">Customer</a></li>
                      </ul>
                    </li>

                    <li className="nav-item">
                      <button className="nav-link"><FaGem /> GeM</button>
                      <ul className="drop-task">
                        <li><a href="/gemEnalbeFilterlist">GeM Filter</a></li>
                        <li><a href="/gemBidList">GeM Bid List</a></li>
                        <li><a href="/gemPendingList">GeM Pending List</a></li>
                        <li><a href="/gemCompletedList">GeM Completed List</a></li>
                      </ul>
                    </li>

                  </>
                )}
              </>
            )}
          </ul>
        </div>
      </nav >
    </>
  );
};

export default Navbar;
